var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDirections(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4129 33.5313L27.5305 11.2752C27.8624 10.777 28.1949 10.4445 28.7759 10.1954C30.0213 9.69726 31.3502 10.1954 32.0147 11.1918L46.1322 33.531C47.3777 35.5242 45.634 38.0151 43.3088 37.4341L35.5859 35.6071V57.8632C42.0634 51.6349 50.8662 47.8145 60.4995 47.6488L58.6725 39.8424C58.1743 37.6001 60.6657 35.7731 62.5756 37.019L84.8318 51.1366C85.3299 51.4685 85.6624 51.801 85.9115 52.382C86.4097 53.6275 85.9115 54.9563 84.9152 55.6208L62.576 69.7383C60.5827 70.9838 58.0918 69.2402 58.6729 66.9149L60.4999 59.192C46.7142 59.524 35.5863 70.9016 35.5863 84.77V87.0952C35.5863 88.0916 34.839 88.8395 33.842 88.8395H25.7866C24.7903 88.8395 24.0424 88.0922 24.0424 87.0952V35.6072L16.3195 37.4342C13.912 38.0152 12.1678 35.5243 13.4132 33.531L13.4129 33.5313Z",
    fill: "#88C62C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirections);
export default __webpack_public_path__ + "static/media/directions.35dd930f910eba6d8d8da020109735f1.svg";
export { ForwardRef as ReactComponent };